import { CartItemModel, CartModel, ConfigurableBundleAddToCartModel } from '@libs/shop/models';

export const CART_STATE_KEY: string = 'cart';

export type CartStateStatus = 'pending' | 'loading' | 'error' | 'success';

export type CartQueueActionType = 'add' | 'changeQuantity' | 'remove' | 'addConfigurableBundle';

export type CartQueueActionData = AddToCartActionData | ChangeQuantityActionData | RemoveActionData | AddConfigurableBundleToCartActionData;

export interface CartQueueActionBaseData {
  sku: string;
}

export interface AddToCartActionData extends CartQueueActionBaseData {
  quantity: number;
}

export interface ChangeQuantityActionData extends CartQueueActionBaseData {
  cartItem: CartItemModel;
}

export interface RemoveActionData extends CartQueueActionBaseData {
  cartItem: CartItemModel;
}

export interface AddConfigurableBundleToCartActionData extends CartQueueActionBaseData {
  data: ConfigurableBundleAddToCartModel;
}

export interface CartQueueItem {
  id: string;
  actionType: CartQueueActionType;
  data: CartQueueActionData;
}

export interface CartState {
  cartId: string;
  cartData: CartModel | undefined;
  error: Error | null;
  status: CartStateStatus;
  cartQueue: CartQueueItem[];
  isCartQueueProcessing: boolean;
}

export const initialCartState: CartState = {
  cartId: '',
  cartData: undefined,
  error: null,
  status: 'pending',
  cartQueue: [],
  isCartQueueProcessing: false,
};
